<template>
  <v-content class="spinelab-website-front">
    <v-container>
      <v-flex xs12 sm12 md12>
        <h1 class="text-sm-left">会員別利用状況</h1>
        <p>※ 毎日午前２時ごろにCSVが更新されます。</p>
      </v-flex>
      <template>
        <v-layout row>
          <v-flex xs3 sm3 md3 lg3 xl3>
            <v-btn color="success" @click="download" :loading="downloading">
              CSVダウンロード
            </v-btn>
          </v-flex>
        </v-layout>
      </template>
    </v-container>
  </v-content>
</template>

<script>
import { mapState } from 'vuex';
import { saveAs } from 'file-saver';
import { convert } from "encoding-japanese";

export default {
  name: 'SiteList',
  data() {
    return {
      downloading: false,
    };
  },
  computed: {
    ...mapState({
      requests: (state) => state.requests,
    }),
  },
  methods: {
    async download() {
      this.downloading = true;
      const csv = await this.requests.getAdminSiteListCSV();
      const sjisCSV = new Uint8Array(
        convert(csv, {
          to: "SJIS",
          from: "AUTO",
          type: "array",
        })
      );
      const blob = new Blob([sjisCSV], { type: "text/csv" });
      saveAs(blob, 'list.csv');
      this.downloading = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/admin/SiteList.vue